import pick from 'lodash/pick';

export type TransitionFunction = (
    from: number,
    to: number,
    passed: number,
    duration: number,
) => number;
export function LINEAR(from: number, to: number, passed: number, duration: number) {
    return from + (to - from) * (Math.min(passed, duration) / duration);
}

const noop = () => {};

export interface TransformProperties {
    [key: string]: number;
}

export function transition(
    element: HTMLElement,
    endValues: TransformProperties,
    func: TransitionFunction = LINEAR,
    duration: number,
    done = noop,
) {
    const target = (element as unknown) as TransformProperties;
    const startValues = pick(target, Object.keys(endValues));
    let elapsed: number = 0;

    function step(timestamp: number) {
        if (!elapsed) {
            elapsed = timestamp;
        }

        Object.keys(endValues).forEach(key => {
            if (typeof startValues[key] !== 'undefined') {
                target[key] = func(startValues[key], endValues[key], timestamp - elapsed, duration);
            }
        });

        if (timestamp - elapsed < duration) {
            requestAnimationFrame(step);
        } else {
            done();
        }
    }

    requestAnimationFrame(step);
}
